import React from 'react';
import * as FaIcons from 'react-icons/fa';
import './Entradas.css';

function MiniEntrada(props) {
    return (
        <div className='miniEntrada' id={props.id} onClick={props.onClick} value={props.nombreSub}>
            <div style={{widt:'100%', display:'flex'}} key={props.id}>
                <div>
                {props.icon === "si" &&
                    <FaIcons.FaPlaneDeparture style={{color:'#1010C5',marginLeft:'5px'}}/>
                }
                </div>
                <div>
                    <label style={{marginLeft:'15px'}}>{props.nombreSub}</label>
                </div>
                
            </div>
            <div  style={{position:'relative',marginLeft:'auto',color:'#7D97F4'}}>
                <label style={{cursor:'pointer'}}> Agregar entrada</label>
            </div>
    
        </div>
      )
}

export { MiniEntrada };
